/**
 * The names of the things on the table that can be pointed at.
 *
 * One string per object, stable while the object is: the canvas draws it, the
 * hit layer lays a button over it, the tooltip explains it, and a test can ask
 * for it — all by this name, so none of them has to know how the others work.
 */
import type { ActionKind } from '@trajan/engine';

export type TargetId =
  // the board
  | 'time'
  | `demand:${number}`
  | `forum:${number}`
  | `yellow:${number}`
  | `province:${string}`
  | 'italia'
  | `site:${number}`
  | `stack:${number}`
  | `senate:${number}`
  | `bonus:${number}`
  | `ship:${string}`
  | 'deck'
  | `pile:${number}`
  // the mat
  | `tray:${number}`
  | `slot:${number}`
  | `marker:${number}`
  | `plus2:${ActionKind}`
  // the rest of the tableau
  | 'vp'
  | 'supply'
  | 'camp:legion'
  | 'camp:workers'
  | `held:${string}`
  | `card:${string}`
  | 'display';

/** The part of a target's name before the colon: what kind of thing it is. */
export const kindOf = (id: TargetId): string => {
  const colon = id.indexOf(':');
  return colon < 0 ? id : id.slice(0, colon);
};

/** The part after the colon, or '' for a target that is one of a kind. */
export const argOf = (id: TargetId): string => {
  const colon = id.indexOf(':');
  return colon < 0 ? '' : id.slice(colon + 1);
};
